module.exports = __webpack_public_path__ + "img/lesson_09.32b2bea8.jpg";